import { nanoid } from "nanoid";
import {
  ChannelHistory,
  ServerMessageElement,
  StreamChunk,
} from "@/types/chat";

export type AnswerReference = {
  id: string;
  content: string;
  source: string;
  highlight?: string;
};

export type ChatMessage = {
  id: string; // 本地创建的 nanoid，每个消息的 id 都是唯一的
  historyId?: number; // 服务器返回的 id, 一对 QA 是同一个 historyId
  role: "user" | "server";
  content: string | StreamChunk[] | ServerMessageElement[];
  loading?: boolean;
  streamDone?: boolean; // 流式数据是否结束
  isError?: boolean;
  createTime?: string | Date;
  updateTime?: string | Date;
  references?: AnswerReference[];
  stream?: boolean; // 默认不是，代表旧版一次性返回的 elements 结构，为 true 代表流式数据
};

export function createMessage(override: Partial<ChatMessage>): ChatMessage {
  return {
    id: nanoid(),
    createTime: new Date(),
    updateTime: new Date(),
    role: "user",
    content: "",
    ...override,
  };
}

export function getMessageListByHistory(data: ChannelHistory[]): ChatMessage[] {
  const list: ChatMessage[] = [];
  data.forEach((item) => {
    const user: ChatMessage = createMessage({
      role: "user",
      content: item.question,
      createTime: item.createtime,
      historyId: item.id,
    });

    const content =
      item.recommand === "stream_response"
        ? JSON.parse(item.answer) // 新的流式数据
        : JSON.parse(item.source).elements; // 旧的一次性返回的 elements 结构

    const server: ChatMessage = createMessage({
      role: "server",
      createTime: item.createtime,
      content: content,
      stream: item.recommand === "stream_response",
      streamDone: true,
      historyId: item.id,
    });
    list.push(user, server);
  });
  return list;
}
